import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import { getAsset } from '../../../../../../../../util/assets';
import { getGalleriesFromHierarchyItems } from '../../helpers';

const propTypes = {
  accountProfile: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const ProfilePageHelmet = ({ accountProfile }) => {
  const futureGalleries = getGalleriesFromHierarchyItems(
    accountProfile.future_hierarchy_items?.records ?? [],
  );
  const pastGalleries = getGalleriesFromHierarchyItems(
    accountProfile.past_hierarchy_items?.records ?? [],
  );

  const pageTitle = accountProfile.organization_name
    ? `${accountProfile.organization_name} - Waldo Photos`
    : 'Waldo Photos';
  const canonicalUrl = `https://waldophotos.com/@${accountProfile.username}`;
  const pageDescription = `Get your ${
    accountProfile.organization_name || ''
  } photos delivered directly to your phone.`;
  const defaultImageUrl = getAsset('/web-galleries/images/tiles.svg');
  const ogImageUrl =
    accountProfile?.logo_image?.url ??
    futureGalleries?.[0]?.coverPhotoUrl ??
    pastGalleries?.[0]?.coverPhotoUrl ??
    defaultImageUrl;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={ogImageUrl} />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

ProfilePageHelmet.propTypes = propTypes;

export default ProfilePageHelmet;
